import EBarBoardOfProfessionalsCTA from './EBarBoardOfProfessionalsCTA';

export default EBarBoardOfProfessionalsCTA;
